import e from "./highrise1320.mjs";
import r from "./highrise1420.mjs";
import o from "./highrise1418.mjs";
var g = "[object Arguments]", b = "[object Array]", c = "[object Boolean]", j = "[object Date]", n = "[object Error]", T = "[object Function]", i = "[object Map]", y = "[object Number]", p = "[object Object]", A = "[object RegExp]", f = "[object Set]", u = "[object String]", m = "[object WeakMap]", s = "[object ArrayBuffer]", l = "[object DataView]", d = "[object Float32Array]", I = "[object Float64Array]", U = "[object Int8Array]", k = "[object Int16Array]", w = "[object Int32Array]", x = "[object Uint8Array]", B = "[object Uint8ClampedArray]", F = "[object Uint16Array]", M = "[object Uint32Array]", a = {};
a[d] = a[I] = a[U] = a[k] = a[w] = a[x] = a[B] = a[F] = a[M] = !0;
a[g] = a[b] = a[s] = a[c] = a[l] = a[j] = a[n] = a[T] = a[i] = a[y] = a[p] = a[A] = a[f] = a[u] = a[m] = !1;
function E(t) {
  return o(t) && r(t.length) && !!a[e(t)];
}
export {
  E as default
};
